import { WizardSteps } from "../../components/wizard/WizardStepper";

export const OnboardingSteps: WizardSteps = [
  { name: "Privacy policy & terms" },
  { name: "Setup your profile" },
  // { name: "Configure your building" },
  // { name: "Enable 2FA" },
];
